<template>
  <div>
    <LogoImg/>
    <NavBar/>
    <NavMobile/>
    <GradientMap/>
    <!-- <MainBanner/> -->
    <IconText :blockContent="privacy_policy"
              :buttonContent="no_button"/>
    <Footer/>
  </div>
</template>

<script>
import LogoImg from './LogoImg.vue'
import NavBar from './NavBar.vue'
import GradientMap from './GradientMap.vue'
// import MainBanner from './MainBanner.vue'
import IconText from './IconText.vue'
import Footer from './Footer.vue'
import NavMobile from './NavMobile.vue'


export default {
  name: 'PagePP',
  components: {
    LogoImg,
    NavBar,
    GradientMap,
    // MainBanner,
    IconText,
    Footer,
    NavMobile
  },
  data () {
    return {
      privacy_policy: {
        icon: ``,
        paragraph: 'Niniejsza Polityka Prywatności jest zgodna z przepisami wynikającymi z  art. 13 ust. 1 i ust. 2 rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z 27 kwietnia 2016 r. w skrócie RODO.<br><br>Administratorem Państwa danych osobowych jest firma:<br>Elbo Logistyka Sp. z o.o.<br>ul. Nad Sołą 1005<br>34-382 Wieprz<br>e-mail: <a href="mailto:biuro@elbologistyka.pl ">biuro@elbologistyka.pl </a><br>telefon: <a href="tel:0048515216203">+48 515 216 203</a><br><br><br><ul><li>Przetwarzanie Państwa danych osobowych odbywa się na podstawie art. 6 RODO i w celach marketingowych Administrator Danych Osobowych powołuje się na prawnie uzasadniony interes, którym jest analityka internetowa strony www oraz analiza jej odwiedzin.</li><br><li>Akceptując zasady polityki prywatności firmy wyrażają Państwo zgodę na przetwarzani danych osobowych przez firmę Elbo Logistyka Sp. z o.o. z siedzibą w Wieprzu przy ul. Nad Sołą 1005, w celu marketingowym. Podanie przez Państwa danych osobowych jest dobrowolne a podstawą ich przetwarzania jest Państwa zgoda. Odbiorcami danych jest Google Analytics.</li><br><li>Państwa dane osobowe będą przechowywane przez okres 5 lat do czasu wykorzystania możliwości marketingowych i analizy danych potrzebnych do prowadzenia działalności gospodarczej lub do odwołania zgodny na przetwarzanie danych osobowych.</li><br><li>Prawo do wycofania się ze zgody na przetwarzanie danych osobowych może nastąpić w dowolnym terminie. Dane osobowe będą przetwarzane do czasu jej odwołania.</li><br><li>Mają Państwo prawo dostępu do swoich danych osobowych, ich sprostowania, usunięcia lub ograniczenia przetwarzania, a także do wniesienia skargi do organu nadzorującego.</li></ul>'
      },
      no_button: {
        url: '',
        label: ''
      }
    }
  }
}
</script>
